<template>
  <div class= "communityInfoManageList">
     <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-show="type==1" placeholder="请输入楼号" v-model="gardenGridsName1">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-show="type==2" placeholder="请输入单元号" v-model="gardenGridsName2">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-show="type==3" placeholder="请输入房间号" v-model="gardenGridsName3">
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">查询</el-button>
        <el-button type="primary" @click="download()">{{$t('lang.btn_downloadTemplate')}}</el-button>
            <el-upload
              class="upload-demo"
              ref="uploading"
              :on-remove="handleRemove"
              :on-change="handleSuccess"
              :on-error="uploadErr1"
              accept=".xlsx, .xls"
              action
              :file-list="fileList"
              :limit="1"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="success"
                @click="submitUpload"
              >上传到服务器</el-button>
            </el-upload>
        </el-form>
      </div>
    <el-card>
      <div class="card-header">
        <div style="flex: 1;">
          <el-tag v-if="currentPath" class="path-tag">当前位置：{{ currentPath }}</el-tag>
        </div>
        <el-button type="primary" slot="header" @click="back" v-if="type === 2">{{$t('lang.btn_returnHomepageManage')}}</el-button>
        <el-button type="primary" slot="header" @click="back" v-if="type === 3">{{$t('lang.btn_returnHouseManage')}}</el-button>
        <el-button type="danger" slot="header" v-if="type === 3&&showbatchDelBtn" :disabled="selectArr.length<2" @click="batchDel('')">批量删除</el-button>
        <el-button type="primary" slot="header" @click="add" v-if="type === 1">{{$t('lang.btn_addHouseId')}}</el-button>
        <el-button type="primary" slot="header" @click="add" v-if="type === 2">{{$t('lang.btn_addUnitId')}}</el-button>
        <el-button type="primary" slot="header" @click="add" v-if="type === 3">{{$t('lang.btn_addRoomId')}}</el-button>  
      </div>       
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" :header-cell-class-name="cellClass" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column prop="name" :label='column'></el-table-column>
        <el-table-column label="虚拟位置">
          <template slot-scope="scope">
            <span v-if="scope.row.virtualPosition === 0">否</span>
            <span v-if="scope.row.virtualPosition === 1">是</span>
          </template>
        </el-table-column>
        <el-table-column label="是否空置房" v-if="type === 3">
          <template slot-scope="scope">
            <span v-if="scope.row.noUseRoom === 0">否</span>
            <span v-if="scope.row.noUseRoom === 1">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="staffName" :label='staffName' v-if="type === 2"></el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
        <template slot-scope="scope">
          <el-button @click="details(scope.row)" v-if="type === 1 || type === 2">下级</el-button>
          <el-button @click="edit(scope.row)" >{{$t('lang.btn_modify')}}</el-button>
          <el-button class="orange" v-if="showbatchDelBtn" @click="deleteOne(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws2" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="isTitle" prop="name" class="item-input">
          <input style="display: none"/>
          <el-input v-model="form.name" :placeholder="$t('lang.lab_pleaseEnterCItext')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="虚拟位置">
						<el-radio-group v-model="form.virtualPosition">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
        <el-form-item label="是否空置房" v-if="type === 3">
						<el-radio-group v-model="form.noUseRoom">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:communityInfoManageList
 *@Description:小区信息管理
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-13
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    // 表格内容默认数据
    return {
      isDisabled: true, // 保存的可点击
      type: 1, // 1:楼号 2：单元号 3：房间号
      isPopupPage: false, // 弹框的显示控制
      isAdd: false, // 标识新增(true)或编辑(false)
      parentId: '', // 上一级id
      parentName: '', // 上一级名字
      editId: '', // 正在编辑的ID
      title: '', // 弹窗标题
      isTitle: '', // 弹窗label
      column: this.$i18n.t('lang.lab_isHouseId'), // 列表标题
      staffName: this.$i18n.t('lang.lab_housekeeper'), // 二级列表管家标题
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 列表数据
      multipleSelection: [], // 多选框
      communityInfoManagecheckbox: require('@/config/enum').communityInfoManagecheckbox, // 是否隐藏复选框
      form: {
        name: '',
        noUseRoom: 0,
        virtualPosition: 0
      },
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.lab_pleaseEnterCItext'), trigger: 'blur' }],       
      },
      selectArr: [], // 批量删除id数组
      showbatchDelBtn: false, // 批量删除按钮显示状态（true显示  false隐藏）
      DisableSelection: true,
      gardenGridsName1: '', // 楼号搜索框
      gardenGridsName2: '', // 单元号搜索框
      gardenGridsName3: '', // 房间搜索框
       pathTitle: '', // 存储完整路径标题
    }
  },
  created() {
    this.parentId = this.gardenId
    this.getData()
    this.getLastDate()
  },
  computed: {
    ...mapGetters(['gardenId', 'userGardenList'])
  },
  watch: {
    gardenId: function (newtype, oldtype) {
      this.parentId = this.gardenId
      this.type = 1
      this.commit()
    },
    form: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    selectable(row, index) {
      if (this.type == 3 && this.showbatchDelBtn) {
        this.DisableSelection = false && this.DisableSelection
        return true
      } else {
        return false
      }
    },
    // 全选按钮隐藏
    cellClass(row) {
      if (this.DisableSelection) {
        if (row.columnIndex === 0) {
          return 'DisableSelection'
        }
      }   
    },
    // 获取是否有删除权限
    getLastDate() {
        let lastDate = ''
        this.userGardenList.map(item => {
          if (item.id == this.gardenId) {
            lastDate = item.gardenDeleteValid
          }
        })
        const lastTimestamp = new Date(lastDate).getTime()
        const nowTimestamp = new Date().getTime()
        console.log('现在时间戳：' + nowTimestamp)
        console.log('最后时间戳：' + lastTimestamp)
        if (lastTimestamp > nowTimestamp) {
          console.log('有权限')
          this.showbatchDelBtn = true
        }
      },
       // 下载模板
    download() {
      window.open(require('@/config/enum').mouldGardenGrid)
    },
    // 上传文件的断网
    uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
            const loading = this.$loading()
            setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
            }, 500)
        }
    },
    handleSuccess(e) {
      this.fileLists = e.raw
    },
    // 移除文件
    handleRemove() {
      this.fileList = []
      this.fileLists.length = 0
    },
    // 图片上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
    },
    // 导入按钮
    submitUpload() {
      if (this.fileLists.length < 1) {
        this.$message.warning(this.$i18n.t('lang.key_up_file'))
      } else {
        let formData = new FormData()
        formData.append('excelFile', this.fileLists)
        let loading = this.$loading()
        this.$postFormData(`/importGardenGrid`, formData).then(
          res => {
            loading.close()
            this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
            this.fileList = []
            this.commit()
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
      let selectArr = []
        val.forEach(element => {
          selectArr.push(element.id)
        })
        this.selectArr = selectArr
        console.log(selectArr)
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 进入页面后默认显示
    getData() {
      let loading = this.$loading()
      this.$get(`/gardenGrids?gardenGridsName=${this.gardenGridsName1}&type=${this.type}&parentId=${this.parentId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )   
    },
    // 返回
    back() {
      this.type--
      if (this.type === 1) {
        this.column = this.$i18n.t('lang.lab_isHouseId')
        this.pathTitle = '' // 清空路径
        this.currentPath = ''
      }
      if (this.type === 2) {
        this.column = this.$i18n.t('lang.lab_isUnitId')
        this.pathTitle = this.pathTitle.split('-')[0]
        this.currentPath = this.pathTitle
      } else if (this.type === 3) {
        this.column = this.$i18n.t('lang.lab_isRoomId')
        this.pathTitle = this.pathTitle.split('-')[0] + '-' + this.pathTitle.split('-')[1]
        this.currentPath = this.pathTitle
      }
      this.DisableSelection = true
      let loading = this.$loading()
      this.$get(`/gardenGridsParent/${this.parentId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.parentId = res.id
            this.commit()
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加
    add() {
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.btn_addHouseId')
        this.isTitle = this.$i18n.t('lang.lab_isHouseId')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.btn_addUnitId')
        this.isTitle = this.$i18n.t('lang.lab_isUnitId')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.btn_addRoomId')
        this.isTitle = this.$i18n.t('lang.lab_isRoomId')
      }
      this.isPopupPage = true
      this.isAdd = true
    },
    // 编辑
    edit(rowData) {
      if (this.type === 1) {
        this.title = this.$i18n.t('lang.lab_modifyHouseId')
        this.isTitle = this.$i18n.t('lang.lab_isHouseId')
      } else if (this.type === 2) {
        this.title = this.$i18n.t('lang.lab_modifyUnitId')
        this.isTitle = this.$i18n.t('lang.lab_isUnitId')
      } else if (this.type === 3) {
        this.title = this.$i18n.t('lang.lab_modifyRoomId')
        this.isTitle = this.$i18n.t('lang.lab_isRoomId')
      }
      this.editId = rowData.id
      this.form.name = rowData.name
      this.form.virtualPosition = rowData.virtualPosition
      this.form.noUseRoom = rowData.noUseRoom
      this.isPopupPage = true
      this.isAdd = false
      this.saveData = JSON.stringify(this.form)
    },
    // 详情
    details(data) {
      this.type++
      if (this.type === 2) {
        this.column = this.$i18n.t('lang.lab_isUnitId')
        this.pathTitle = data.name // 保存楼号
        this.currentPath = this.pathTitle
      }
      if (this.type === 3) {
        this.column = this.$i18n.t('lang.lab_isRoomId')
        this.pathTitle = this.pathTitle + '-' + data.name
        this.currentPath = this.pathTitle
      }
      this.parentId = data.id
      this.parentName = data.name
      this.commit()
    },
    // 删除
    deleteOne(row) {
      let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            let params = {
              idArr: row.id
            }
            this.$delete(`/gardenGrids/delByBatch`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('删除成功')
                    this.commit()
                  }
                },
                error => {
                  console.log(error)
                  loading.close()
                  this.$message.error(error)
                }
              )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
    // 批量删除
    batchDel() {
      let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            let params = {
              idArr: this.selectArr.join(',')
            }
            this.$delete(`/gardenGrids/delByBatch`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('删除成功')
                    this.commit()
                  }
                },
                error => {
                  console.log(error)
                  loading.close()
                  this.$message.error(error)
                }
              )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
    // 获取数据
    obtainData(type) {
      let gardenGridsName = ''
      if (this.type === 2) {
        gardenGridsName = this.gardenGridsName2
      } else if (this.type === 3) {
        gardenGridsName = this.gardenGridsName3
      }
      let loading = this.$loading()
      this.$get(`/gardenGrids?gardenGridsName=${gardenGridsName}&type=${this.type}&parentId=${this.parentId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&parentName=${this.parentName}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )   
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.difference()
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            let params = {
              type: this.type,
              parentId: this.parentId,
              name: this.form.name,
              virtualPosition: this.form.virtualPosition,
              noUseRoom: this.form.noUseRoom,
            }
            let loading = this.$loading()
            this.$post(`/gardenGrids`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              id: this.editId,
              type: this.type,
              parentId: this.parentId,
              name: this.form.name,
              virtualPosition: this.form.virtualPosition,
              noUseRoom: this.form.noUseRoom,
            }
            this.$patch(`/gardenGrids/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } 
        }
      })
    },
    // 清空
    resetForm() {
      this.$refs.form.clearValidate()
      this.form.name = ''
      this.form.virtualPosition = 0
      this.form.noUseRoom = 0
    },
    // 监听关闭dialog
    handleDialogClosed() {   
      this.resetForm()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.difference()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.difference()
    },
    // 区分第一和二、三层
    difference() {
      if (this.type === 1) {
        this.getData()
      } else {
        this.obtainData(this.type)
      }
    }
  }
}
</script>

<style lang= 'scss'>
.communityInfoManageList{
  .item-input{
    width: 90%;
  }
  .el-table .DisableSelection .cell .el-checkbox__inner{
          display: none;
          position: relative;
        }
  .el-table .DisableSelection .cell:before{
          content: "";
          position: absolute;
  }
  .card-header {
    display: flex;
    align-items: center;

    .path-tag {
      margin-left: 20px;
      padding: 0 15px;
    }
  }
}
 .communityInfoManageList .upload-demo {
    display: inline;
    padding-left: 20px;
  }
</style>